import { render } from "./VillaType.vue?vue&type=template&id=6a400a94&scoped=true"
import script from "./VillaType.vue?vue&type=script&lang=js"
export * from "./VillaType.vue?vue&type=script&lang=js"

import "./VillaType.vue?vue&type=style&index=0&id=6a400a94&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a400a94"]])

export default __exports__